import { ProfressionalSubscriptionModel } from '../../models/subscription/professional-subscription.model';
import { PurchaseSubscriptionModel } from '../../models/utils/subscription';
import { SubscriptionPlanModel } from '../../models/subscription/subscription-plan.model';
import { BraintreePaymentRequest } from '../../models/subscription/braintree-payment-request.model';

export class ResetSubscriptionState {
  static readonly type = '[Subscription] Reset Subscription State';
  constructor() { }
}

export class BuySubscription {
  static readonly type = '[Subscription] Buy Subscription';
  constructor(public request: PurchaseSubscriptionModel) { }
}

export class BuySubscriptionSuccess {
  static readonly type = '[Subscription] Buy Subscription Success';
  constructor(public request: PurchaseSubscriptionModel) { }
}

export class BuySubscriptionFailure {
  static readonly type = '[Subscription] Buy Subscription Failure';
  constructor(public error: Error) { }
}

export class UpdateSubscription {
  static readonly type = '[Subscription] Update Subscription';
  constructor(public request: BraintreePaymentRequest) { }
}

export class UpdateSubscriptionSuccess {
  static readonly type = '[Subscription] Update Subscription Success';
  constructor() { }
}

export class UpdateSubscriptionFailure {
  static readonly type = '[Subscription] Update Subscription Failure';
  constructor(public error: Error) { }
}

export class CancelSubscription {
  static readonly type = '[Subscription] Cancel Subscription';
  constructor() { }
}

export class CancelSubscriptionSuccess {
  static readonly type = '[Subscription] Cancel Subscription Success';
  constructor() { }
}

export class CancelSubscriptionFailure {
  static readonly type = '[Subscription] Cancel Subscription Failure';
  constructor(public error: Error) { }
}

// Promo Code
export class CheckPromoCode {
  static readonly type = '[Subscription] Check Promo Code';
  constructor(public planId: string, public code: string) { }
}

export class CheckPromoCodeSuccess {
  static readonly type = '[Subscription] Check Promo Code Success';
  constructor(public code: string, public plan: SubscriptionPlanModel) { }
}

export class CheckPromoCodeFailure {
  static readonly type = '[Subscription] Check Promo Code Failure';
  constructor(public err: Error) { }
}

export class RemovePromoCode {
  static readonly type = '[Subscription] Remove Promo Code';
  constructor() { }
}

// Braintree Plans
export class GetPremiumPlans {
  static readonly type = '[Subscription] Get Premium Plans';
  constructor() { }
}

export class GetPremiumPlansSuccess {
  static readonly type = '[Subscription] Get Premium Plans Success ';
  constructor(public plans: SubscriptionPlanModel[]) { }
}

export class GetPremiumPlansFailure {
  static readonly type = '[Subscription] Get Premium Plans Failure';
  constructor(error: Error) { }
}

export class SetPremiumPlan {
  static readonly type = '[Subscription] Set Premium Plan';
  constructor(public plan?: SubscriptionPlanModel) { }
}
